import { handleCreateCommand } from './commands/grid_form_command_handler';

import { generateUUID } from 'utils/uuid';

export default {
	execute,
};

function execute({ dataRow, dataRows, dataRowIdField }, totalCount, commands) {
	const dataRowToInsert = Object.assign(dataRow, { [dataRowIdField]: generateUUID() });
	const updatedCommands = handleCreateCommand(commands, dataRowToInsert);

	return {
		...updatedCommands,
		dataRows: [...dataRows, dataRow],
		totalCount: totalCount + 1,
	}
}
